import React from 'react';
import ReactDOM from 'react-dom/client';

import App from '../app';
import { BgLandscapePng, BgPortraitPng } from '../assets';
import { bootPwa, isStandaloneDisplay } from '../services/pwa';

// Before anything else: Chrome fires `beforeinstallprompt` as soon as the page qualifies,
// and the install nudge needs that event kept.
bootPwa();

// Painted on html / body / #root so there is no white flash before React mounts. It has to be
// the same artwork the app itself paints, or the boot frame shows a different background than
// the one that replaces it.
const isDesktopLandscape = window.innerWidth >= 768 && window.innerWidth > window.innerHeight;
const bootBg = `url(${isDesktopLandscape ? BgLandscapePng : BgPortraitPng})`;
document.documentElement.style.backgroundImage = bootBg;
document.documentElement.style.backgroundSize = 'cover';
document.documentElement.style.backgroundPosition = 'center';
document.documentElement.style.backgroundRepeat = 'no-repeat';
document.documentElement.style.height = '100%';
document.documentElement.style.minHeight = '100%';
document.body.style.margin = '0';
document.body.style.backgroundImage = bootBg;
document.body.style.backgroundSize = 'cover';
document.body.style.backgroundPosition = 'center';
document.body.style.backgroundRepeat = 'no-repeat';
document.body.style.height = '100%';
document.body.style.minHeight = '100%';
document.body.style.overflow = 'hidden';
const rootEl = document.getElementById('root') as HTMLElement;
if (rootEl) {
	rootEl.style.backgroundImage = bootBg;
	rootEl.style.backgroundSize = 'cover';
	rootEl.style.backgroundPosition = 'center';
	rootEl.style.backgroundRepeat = 'no-repeat';
	rootEl.style.height = '100%';
	rootEl.style.minHeight = '100%';
	rootEl.style.overflow = 'hidden';
}

import packageJson from '../../package.json';

// When a web payment finished, the checkout popup tab is redirected back to the app
// with `?payment=success|cancelled&deposit_id=...`. Store the result in localStorage
// for the main tab and close the popup instead of booting the app in the background.
// Only consume the callback when a payment was actually initiated in this browser
// (the initiating tab stores `package_<depositId>` before opening the checkout tab).
// The installed app (PWA) has no popup: the checkout ran in this very page, so this is
// the app coming back and must boot normally; `usePaymentStatus` reads the result from
// the URL.
function handleWebPaymentCallback(): void {
	try {
		if (isStandaloneDisplay()) return;

		const params = new URLSearchParams(window.location.search);
		const payment = params.get('payment');
		if (payment !== 'success' && payment !== 'cancelled') return;

		const depositId = params.get('deposit_id') || '';
		if (!depositId || !window.localStorage.getItem(`package_${depositId}`)) {
			return;
		}

		window.localStorage.setItem(
			'web_payment_result',
			JSON.stringify({
				status: payment,
				depositId,
				sessionId: params.get('session_id') || '',
			}),
		);
		window.close();
	} catch (e) {
		console.warn('[paymentCallback] Callback handling failed, falling back to normal boot:', e);
	}
}
handleWebPaymentCallback();

const root = ReactDOM.createRoot(rootEl);
console.log(
	`%c💎 Svara Web App v${packageJson.version} | Built: ${new Date().toISOString()}`,
	'background: #111; color: #00d2ff; padding: 4px; font-weight: bold; border-radius: 4px;',
);
root.render(<App />);
